import { render } from "./TheHeader.vue?vue&type=template&id=011cb32c&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=011cb32c&lang=scss"
import "./TheHeader.vue?vue&type=style&index=1&id=011cb32c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-011cb32c"]])

export default __exports__